<template>
  <el-tabs :value="active"
           class="order-appeal-list-tabs"
           @tab-click="onTabClick">
    <el-tab-pane label="申诉列表"
                 name="appeal"></el-tab-pane>
    <el-tab-pane label="实习生统计"
                 name="internStat"></el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: 'OrderAppealListTabs',
  props: {
    active: {
      type: String,
      required: true,
    },
  },
  methods: {
    onTabClick (tab) {
      const name = tab.name
      if (name === this.active) return
      if (name === 'internStat') {
        this.$router.push({path: '/order/appeal/intern-stat'})
        return
      }
      this.$router.push({path: '/order/appeal/table'})
    },
  },
}
</script>

<style lang="scss"
       scoped>
.order-appeal-list-tabs {
  /deep/ .el-tabs__header {
    margin: 0 0 12px;
  }

  /deep/ .el-tabs__content {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/OrderAppealListTabs.vue